import { Component, OnInit } from '@angular/core';

import { PanelLoadAction } from './_actions/panel-load.action';

@Component({
  selector: 'carrier-panel',
  templateUrl: './panel.component.html',
  styleUrls: ['./panel.component.scss']
})
export class PanelComponent implements OnInit {

  constructor(
    private loadAction: PanelLoadAction
  ) { }

  ngOnInit(): void {
    this.loadAction.currentDriver();
  }

}
